import { useContext, useState } from "react";
import { AuthContext, AuthContextType } from "../../context/AuthProvider";
import ApiInterface from "./api-interface";
import { API_HTTP, resumeAnalyzerApiEndpoints } from "./endpoints";
import { CancelSubscriptionPayload } from "../../DataModels/DataModels";

const useCancelSubscription = () => {
	const { user } = useContext(AuthContext) as AuthContextType;
	const [pending, setPending] = useState<boolean>(false);

	const cancelSubscription = async (): Promise<void> => {
		if (!user) {
			throw new Error("User is not authenticated");
		}
		const apiClient = new ApiInterface(API_HTTP.resumeAnalyzer, user);
		const payload: CancelSubscriptionPayload = {
			action: "cancel-subscription"
		};
		setPending(true);
		try {
			await apiClient.post(resumeAnalyzerApiEndpoints.orders, payload);
		} finally {
			setPending(false);
		}
	};

	return { cancelSubscription, cancellationPending: pending };
};

export default useCancelSubscription;
